import { h } from "@stencil/core";
import { renderShowcaseProperties } from "../utils";
import { basicModel, groupModel, propertyGridModel, treeGridModel } from "./models";
const state = {};
const render = () => (h("ch-tabular-grid-render", { model: state.model, theme: "showcase-tabular-grid" }, h("ch-theme", { model: {
        name: "showcase-tabular-grid-icons",
        url: "https://unpkg.com/@genexus/mercury@0.8.9/dist/bundles/css/base/icons.css",
        themeBaseUrl: "https://unpkg.com/@genexus/mercury@0.8.9/dist/"
    } }), h("ch-theme", { model: {
        name: "showcase-tabular-grid",
        url: "https://unpkg.com/@genexus/mercury@0.8.9/dist/bundles/css/components/tabular-grid.css"
    } })));
const showcaseRenderProperties = [
    {
        caption: "Models",
        properties: [
            {
                id: "model",
                accessibleName: "Model",
                type: "enum",
                values: [
                    { caption: "Basic", value: basicModel },
                    { caption: "Group", value: groupModel },
                    { caption: "TreeGrid", value: treeGridModel },
                    { caption: "PropertyGrid", value: propertyGridModel }
                ],
                value: basicModel
            }
        ]
    }
];
const showcasePropertiesInfo = [{ name: "model", fixed: true, value: "controlUIModel", type: "function" }];
export const tabularGridRenderShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithUIModel: {
        uiModel: () => state.model,
        uiModelType: "TabularGridModel",
        render: {
            react: () => `<ChTabularGridRender${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
        >
        </ChTabularGridRender>`,
            stencil: () => `<ch-tabular-grid-render${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
          >
          </ch-tabular-grid-render>`
        }
    },
    render: render,
    state: state
};
